export default __webpack_public_path__ + "static/media/pirate.f1fea1d6.mkv";